import React from 'react'
import PropTypes from 'prop-types'
import EmptyState from 'components/ds/EmptyState'

const NoDataIndication = ({ message, className, waitingAction = false, kind, action }) => (
  <EmptyState
    kind={kind || (waitingAction ? 'all-clear' : 'empty')}

    title={message}
    description={message ? '' : undefined}
    action={action}
    className={className}
  />
)

NoDataIndication.propTypes = {
  message: PropTypes.node,
  className: PropTypes.string,

  waitingAction: PropTypes.bool,

  kind: PropTypes.string,
  action: PropTypes.node,
}

export default NoDataIndication
